import React from "react";
import {
  View,
  Image, 
  StyleSheet,
  TouchableOpacity} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import { SafeAreaView } from "react-native-safe-area-context";
import commonStyles from "../../../styles/commonStyles";
import IraAccountStyle from "./IraAccountStyle";
import AppText from "../../../components/AppText";


type ProfileProps = {
  navigation: {
    navigate: (screen: string, params?: object) => void;
    goBack: () => void;
  };
};

const IraAccount: React.FC<ProfileProps> = ({ navigation }) => {
  return (
    <SafeAreaView
      edges={["bottom", "left", "right"]}
      style={[styles.container, commonStyles.screenBottomGap]}
    >
      <TouchableOpacity
        onPress={navigation.goBack}
        style={commonStyles.subHeaderContainer}
      >
        <AntDesign name="left" size={24} color="black" />
        <AppText style={commonStyles.subHeader}>IRA Account</AppText>
      </TouchableOpacity>
      <View style={IraAccountStyle.content}>
        <View style={IraAccountStyle.iconContainer}>
          <Image
            source={require("../../../../assets/images/icons/under-construction.png")} 
            style={IraAccountStyle.image} 
          />
        </View>
        <View style={IraAccountStyle.textContainer}>
          <AppText style={IraAccountStyle.text}>Please stay tuned</AppText>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: "#fff"}});

export default IraAccount;
